export default function SidePopupSection({ title, children, style = {} }) {
    return (
        <div className="side-popup__section" style={style}>
            { title && <p className="side-popup-section__title">{ title }</p> }
            { children }
        </div>
    )
}